module.exports = __webpack_public_path__ + "static/npckc1-af466149ef0fbd8a6cde69de1cf6348c.webp";